import { IStripItem } from '../../types/hero';

const defaultState: IStripItem[] = [];

export function stripBlocksReducer(state: IStripItem[] = defaultState) {
  return state;
}
